module.exports = __webpack_public_path__ + "img/1.946f3af5.png";